import { render } from "./CrossStep4.vue?vue&type=template&id=1b83a506"
import script from "./CrossStep4.vue?vue&type=script&lang=js"
export * from "./CrossStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__